import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import "./styles.css";

class DateRangePicker extends Component {
  render() {
    const currentDate = new Date()
    const {
      fromDate,
      toDate,
      handleDateChange
    } = this.props;

    return (
      <Row>
        <Col xs={6} className="padding-right-zero">
          <div className="datepicker margin-zero">
            <p className='vertical-center'>From</p>
            <DatePicker
              name="fromDate"
              maxDate={toDate || currentDate}
              selected={fromDate}
              onChange={date => handleDateChange(date, "fromDate")}
              className="form-control"
            />
          </div>
        </Col>
        <Col xs={6} className="padding-right-zero">
          <div className="datepicker margin-zero">
            <p className='vertical-center'>To</p>
            <DatePicker
              name="toDate"
              minDate={fromDate}
              maxDate={currentDate}
              selected={toDate}
              onChange={date => handleDateChange(date, "toDate")}
              className="form-control"
            />
          </div>
        </Col>
      </Row>
    );
  }
}

export default DateRangePicker;